export default "__VITE_ASSET__81d1f279__"